export default __webpack_public_path__ + "static/transaction-page-request-910f8c5dd8c3cce40d9d6a0f7fc8e08f.png";